export const CODE_TYPES = {
    yaml: 'yaml',
    json: 'json',
    html: 'html',
};
